import React from "react";

import { BsFillInfoCircleFill } from "react-icons/bs";

import "./UsefulMessage.css";

function UsefulMessage({children, message }) {
  return (
    <div className="usefull-message">
      <BsFillInfoCircleFill size={20} />
      <p>{message}</p>
      {children}
    </div>
  );
}

export default UsefulMessage;